// @mui
import { alpha, styled } from '@mui/material/styles';

// ----------------------------------------------------------------------

export const StyledRootScrollbar = styled('div')(({ theme }) => ({
  flexGrow: 1,
  height: '100%',
  overflowY: 'scroll',
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: alpha(theme.palette.grey[600], 0.48),
    borderRadius: '6px',
  },
  '&:before': {
    opacity: 1,
    zIndex: 'inherit',
    transition: 'opacity 0.2s ease',
  },
}));
